import * as Sentry from '@sentry/react';
import { z } from 'zod';
import api from './api';

const MSG_VALIDACAO = 'Erro de validação!';

// Mesma regra de atualizarFaturamentoSchema no icm-backend:
// liberar por laudo exige codLaudo e codPac truthy.
const liberarLaudoPorPacSchema = z
  .object({
    codLaudo: z.any(),
    codPac: z.any(),
  })
  .superRefine((body, ctx) => {
    if (!body.codLaudo || !body.codPac) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: MSG_VALIDACAO,
      });
    }
  });

const updateRequisicao = async payload => {
  const res = await api.put(`/requisicao/${payload.codRequisicao}`, payload);
  return res;
};

const updateAtestado = async payload => {
  const res = await api.put(`/atestado/${payload.codAtestado}`, payload);
  return res;
};

const updateReceita = async payload => {
  const response = await api.put(`/receita/${payload.codReceita}`, payload);
  return response;
};

const liberarLaudoById = async payload => {
  const { fatura } = payload;
  const res = await api.put('/faturamento', fatura);
  return res;
};

const liberarLaudoByPac = async payload => {
  const fatura = (payload && payload.fatura) || {};
  const parsed = liberarLaudoPorPacSchema.safeParse(fatura);

  if (!parsed.success) {
    Sentry.captureMessage('liberarLaudoByPac: codLaudo ou codPac inválidos', {
      level: 'error',
      extra: { fatura },
    });
    throw new Error(parsed.error.errors[0].message);
  }

  const { codLaudo, codPac } = parsed.data;
  const response = await api.put('/faturamento', {
    codLaudo,
    codPac,
  });
  return response.data.message;
};

const insertReceita = async payload => {
  const response = await api.post(`receita/`, payload);
  return response.data;
};

const insertAtestado = async payload => {
  const response = await api.post(`atestado/`, payload);
  return response.data;
};

const insertFatura = async payload => {
  const result = await api.post(`/atividade/fatura/`, payload);
  return result.data; // { message, faturado }
};

const excluirFaturamento = async ({ codFatura, codLaudo, codProcedi }) => {
  const response = await api.delete('/faturamento', {
    data: { codFatura, codLaudo, codProcedi },
  });
  return response.data;
};

const atualizarGuiaConvenio = async payload => {
  const response = await api.put('/faturamento', payload);
  return response.data.message;
};

// TODO: mesmo endpoint que src/redux/features/prontuario/prontuarioSlice.js.
// vamos remover o global e usar só useProntuario no futuro
const buscarProntuarioPorId = async id => {
  const result = await api.get(`paciente/prontuario?id=${id}`);
  return {
    atual: result.data.atual,
    anterior: result.data.anterior,
    anteriores: result.data.anteriores,
  };
};

export {
  updateRequisicao,
  updateAtestado,
  updateReceita,
  liberarLaudoById,
  liberarLaudoByPac,
  insertReceita,
  insertAtestado,
  insertFatura,
  excluirFaturamento,
  atualizarGuiaConvenio,
  buscarProntuarioPorId,
};
